<template>
  <NSpin :show="initLoading" :class="{ 'mt-20': initLoading }">
    <template v-if="!initLoading" style="">
      <!-- <div class="mt-5 p-2 border border-gray-300 flex items-start" style="padding:20px;"> -->
      <div class="mt-5 p-2 border-bottoms" style="padding:0px;padding-bottom: 50px;margin-top:40px;">
        <div class="flex items-start">

          <img class="flex-shrink-0" v-if="userInfo.photo" style="object-fit: cover;width: 225px;height:300px;"
            :src="imgBaseUrl + userInfo.photo" alt="头像信息" />
          <!-- <img class="flex-shrink-0" v-if="userInfo.photo" style="object-fit: cover;width: 126px;height:169px;"
            :src="imgBaseUrl + userInfo.photo" alt="头像信息" /> -->
          <img class="flex-shrink-0" v-else style="object-fit: cover;width: 225px;height:300px;"
            src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/morentouxiang.jpg?n=1" alt="头像信息" />
          <div class="ml-10" style="margin-top:30px;">
            <p class="usernamecss">{{ userInfo.stuName }}</p>
            <p class="mt-4 text-gray-500 text-base">
              <span>
                <img class="jigouico" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/zuzhijigou.png" alt="">
              </span>
              机构：{{ userInfo.tenantName }} <span class="banjiname">
                <span>

                  <span>
                    <img class="jigouico" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/xuexiao_banji.png"
                      alt="">
                  </span>
                  班级：{{ userInfo.className }}

                </span>
              </span>
            </p>
            <p class="mt-2 text-gray-500 text-base" v-if="0">
              <span>
                <img class="jigouico" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/xuexiao_banji.png"
                  alt="">
              </span>
              班级：{{ userInfo.className }}
            </p>
            <p class="mt-2 text-gray-500 text-base">
              <span>
                <img class="jigouico" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/banzhuren.png" alt="">
              </span>
              班主任：{{ userInfo.headTeacherName }}
            </p>
            <p class="mt-4 text-base" style="color: #ea4c00"> 注册时间：{{ userInfo.createTime }} </p>
            <div class="flex" style="margin-top:35px;font-weight: 700;">
              <div class="ambo" style="justify-content: flex-start;flex-direction: row;">
                <el-progress :width='80' stroke-width='10' style="margin:0 auto;  font-weight: 700;" type="circle"
                  :percentage="updatapercentage(credit.onlineCommonLearn,credit.onlineCommonRequire)">
                </el-progress>
                <div style="margin-left:10px;">
                  <div class="percentage-label2 ">
                    <span class="yixuekeshi flex top" style="">
                      <span class="yixuekeshi_dian "
                        :class="updatapercentage(credit.liveLearn,credit.liveRequire)==100?'active':''"></span>
                      <span>
                        通识课
                      </span>
                    </span>
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      已学课时：
                    </span>
                    {{updacredit(credit.onlineCommonLearn)}}
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      总课时：
                    </span>
                    {{updacredit(credit.onlineCommonRequire)}}
                  </div>
                </div>

              </div>
              <div class=" ambo" style="justify-content: flex-start;flex-direction: row;">
                <el-progress :width='80' stroke-width='10' style="margin:0 auto;  font-weight: 700;" type="circle"
                  :percentage="updatapercentage(credit.onlineMajorLearn,credit.onlineMajorRequire)">
                </el-progress>
                <div style="margin-left:10px;flex-shrink">
                  <div class="percentage-label2">

                    <span class="yixuekeshi yixuekeshitop flex top" style="">
                      <span class="yixuekeshi_dian "
                        :class="updatapercentage(credit.onlineMajorLearn,credit.onlineMajorRequire)==100?'active':''"></span>
                      <span>
                        专业课
                      </span>
                    </span>
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      已学课时：
                    </span>
                    {{updacredit(credit.onlineMajorLearn)}}
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      总课时：
                    </span>
                    {{updacredit(credit.onlineMajorRequire)}}
                  </div>
                </div>

              </div>
              <div class=" ambo" style="justify-content: flex-start;flex-direction: row;">
                <el-progress stroke-width='10' :width='80' style="margin:0 auto;  font-weight: 700;" type="circle"
                  :percentage="updatapercentage(credit.liveLearn,credit.liveRequire)">
                </el-progress>
                <div style="margin-left:10px;">
                  <div class="percentage-label2">

                    <span class="yixuekeshi yixuekeshitop flex top" style="">
                      <span class="yixuekeshi_dian "
                        :class="updatapercentage(credit.liveLearn,credit.liveRequire)==100?'active':''"></span>
                      <span>
                        直播课
                      </span>
                    </span>
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      已学课时：
                    </span>
                    {{updacredit(credit.liveLearn)}}
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      总课时：
                    </span>
                    {{updacredit(credit.liveRequire)}}
                  </div>
                </div>

              </div>
              <div class=" ambo" style="justify-content: flex-start;flex-direction: row;">
                <el-progress stroke-width='10' :width='80' style="margin:0 auto;  font-weight: 700;" type="circle"
                  :percentage="updatapercentage(credit.lineLearn,credit.lineRequire)">
                </el-progress>
                <div style="margin-left:10px;">
                  <div class="percentage-label2">

                    <span class="yixuekeshi yixuekeshitop flex top" style="">
                      <span class="yixuekeshi_dian "
                        :class="updatapercentage(credit.lineLearn,credit.lineRequire)==100?'active':''"></span>
                      <span>
                        线下课
                      </span>
                    </span>
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      已学课时：
                    </span>
                    {{updacredit(credit.lineLearn)}}
                  </div>
                  <div class="percentage-label2">
                    <span class="yixuekeshi">
                      总课时：
                    </span>
                    {{updacredit(credit.lineRequire)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex
              justify-center
              items-center
              w-36
              right-10
              h-36
              
            " style="margin-left:auto;margin-right:30px;" v-if="0">
            <img v-if="tableSummaryData.isSurrogate=='不合格'"
              src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/buhege.png" alt="">
            <img v-else src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/hege.png" alt="">
          </div>
        </div>
        <div class="flex" v-if="0" style="margin-top:35px;font-weight: 700;justify-content: space-between;">
          <div class="ambo" style="justify-content: flex-start;flex-direction: row;">
            <el-progress :width='80' stroke-width='10' style="margin:0 auto;  font-weight: 700;" type="circle"
              :percentage="updatapercentage(credit.onlineCommonLearn,credit.onlineCommonRequire)">
            </el-progress>
            <div style="margin-left:10px;">
              <div class="percentage-label2 ">
                <span class="yixuekeshi flex top" style="">
                  <span class="yixuekeshi_dian "
                    :class="updatapercentage(credit.liveLearn,credit.liveRequire)==100?'active':''"></span>
                  <span>
                    通识课
                  </span>
                </span>
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  已学课时：
                </span>
                {{updacredit(credit.onlineCommonLearn)}}
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  总课时：
                </span>
                {{updacredit(credit.onlineCommonRequire)}}
              </div>
            </div>

          </div>
          <div class=" ambo" style="justify-content: flex-start;flex-direction: row;">
            <el-progress :width='80' stroke-width='10' style="margin:0 auto;  font-weight: 700;" type="circle"
              :percentage="updatapercentage(credit.onlineMajorLearn,credit.onlineMajorRequire)">
            </el-progress>
            <div style="margin-left:10px;flex-shrink">
              <div class="percentage-label2">

                <span class="yixuekeshi yixuekeshitop flex top" style="">
                  <span class="yixuekeshi_dian "
                    :class="updatapercentage(credit.onlineMajorLearn,credit.onlineMajorRequire)==100?'active':''"></span>
                  <span>
                    专业课
                  </span>
                </span>
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  已学课时：
                </span>
                {{updacredit(credit.onlineMajorLearn)}}
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  总课时：
                </span>
                {{updacredit(credit.onlineMajorRequire)}}
              </div>
            </div>

          </div>
          <div class=" ambo" style="justify-content: flex-start;flex-direction: row;">
            <el-progress stroke-width='10' :width='80' style="margin:0 auto;  font-weight: 700;" type="circle"
              :percentage="updatapercentage(credit.liveLearn,credit.liveRequire)">
            </el-progress>
            <div style="margin-left:10px;">
              <div class="percentage-label2">

                <span class="yixuekeshi yixuekeshitop flex top" style="">
                  <span class="yixuekeshi_dian "
                    :class="updatapercentage(credit.liveLearn,credit.liveRequire)==100?'active':''"></span>
                  <span>
                    直播课
                  </span>
                </span>
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  已学课时：
                </span>
                {{updacredit(credit.liveLearn)}}
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  总课时：
                </span>
                {{updacredit(credit.liveRequire)}}
              </div>
            </div>

          </div>
          <div class=" ambo" style="justify-content: flex-start;flex-direction: row;">
            <el-progress stroke-width='10' :width='80' style="margin:0 auto;  font-weight: 700;" type="circle"
              :percentage="updatapercentage(credit.lineLearn,credit.lineRequire)">
            </el-progress>
            <div style="margin-left:10px;">
              <div class="percentage-label2">

                <span class="yixuekeshi yixuekeshitop flex top" style="">
                  <span class="yixuekeshi_dian "
                    :class="updatapercentage(credit.lineLearn,credit.lineRequire)==100?'active':''"></span>
                  <span>
                    线下课
                  </span>
                </span>
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  已学课时：
                </span>
                {{updacredit(credit.lineLearn)}}
              </div>
              <div class="percentage-label2">
                <span class="yixuekeshi">
                  总课时：
                </span>
                {{updacredit(credit.lineRequire)}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="px-5 pt-4 pb-10 border-bottoms relative user_info" style="padding-bottom:50px;">
        <n-spin :show="showSituation">
          <template #description>加载中 请稍后!</template>
          <div class="inline-block  title-line mt-8 mintitle_text" style="margin-top:30px;">线上情况</div>
          <n-table align="center" class="w-9/12 mt-8 ml-10" style="width:94%;margin-top:50px;text-align: center;">
            <thead>
              <tr>
                <th>网络课学时</th>
                <th>直播课学时</th>
                <th>考试成绩</th>
            <!--       <th>是否合格</th> -->
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <n-tag class="text-blue-400 suspension" @click="clickWl()">{{
                    tableSummaryData.onLinePeriod
                  }}</n-tag>
                </td>
                <td>
                  <n-tag class="text-blue-400 suspension" @click="clickZB">{{
                    tableSummaryData.liveCredit
                  }}</n-tag>
                </td>
                <td>
                  <n-tag class="text-blue-400 suspension" @click="clickExam">{{
                    tableSummaryData.source
                  }}</n-tag>
                </td>
            <!--     <td :class="tableSummaryData.isSurrogateOff=='不合格'?'cred':'cgr'">{{ tableSummaryData.isSurrogateOff }}
                </td>  -->
              </tr>
            </tbody>
          </n-table>
          <div class="inline-block text-xl title-line mintitle_text" style="margin-top:50px;">线下情况</div>
          <n-table class="w-9/12 mt-8 ml-10" style="width:94%;margin-top:50px;text-align: center;">
            <thead>
              <tr>
                <th>学时</th>
                <th>创业计划书</th>
                <th>评审表</th>
                <th>评审专家</th>
                <th>代领协议</th>
              <!--    <th>是否合格</th>   -->
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <n-tag class="text-blue-400 suspension" @click="xclick()">{{
                    tableSummaryData.offLinePeriod
                  }}</n-tag>
                </td>
                <td>{{ tableSummaryData.planStatusDic }}</td>
                <td>{{ tableSummaryData.isSurrogateOn }}</td>
                <td>
                  <n-tag class="text-blue-400 suspension" @click="appraisal">
                    {{ tableSummaryData.expertOne }}：{{ tableSummaryData.expertOneScore }}
                    {{ tableSummaryData.expertTwo }}：{{ tableSummaryData.expertTwoScore }}
                  </n-tag>
                </td>
                <!-- TODO: 去确定当前字段 0 与 1 对应的值 -->
                <td>{{ tableSummaryData.isEligibility === 1 ? '已领取' : '未领取' }}</td>
             <!--        <td :class="tableSummaryData.isSurrogateOn=='不合格'?'cred':'cgr'">{{ tableSummaryData.isSurrogateOn }}
                </td>   -->
              </tr>
            </tbody>
          </n-table>
          <div v-if="0" class="
              flex
              justify-center
              items-center
              w-36
              right-10
              absolute
              h-36
              border border-gray-300
            " style="margin-top: -72px; top: 50%; border: 1px solid red;right:0px">
            <span style="font-size: 34px">
              {{ tableSummaryData.isSurrogate }}
            </span>
          </div>
          <div class="flex
              justify-center
              items-center
              w-36
              right-10
              absolute
              h-36
            " style="margin-top: -72px; top: 50%; ">
            <!-- <img v-if="tableSummaryData.isSurrogate=='不合格'"
              src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/buhege.png" alt="">
            <img v-else src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/hege.png" alt=""> -->

          </div>
        </n-spin>
      </div>

      <div class="mt-6 px-5 pt-4 pb-10  relative" style="padding-bottom:50px;">
        <div class="inline-block text-xl title-line mintitle_text">信息补录</div>
        <div class="ml-10 mt-8 flex" style="margin-top:50px;">
          <div class="text-center">
            <p class="mb-1">相关证明一</p>
            <Upload @dataChange="dataChange" v-bind:path="formModel.proof" />
            <!-- <n-upload
              action="#"
              :default-upload="false"
              :file-list="[]"
              @change="(...args) => handleUploadChange(0, ...args)"
            >
              <div
                class="cursor-pointer border-2 border-gray-200 flex justify-center items-center"
                style="width: 142px; height: 142px"
              >
                <n-icon size="60" color="#ccc">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="32"
                      d="M256 112v288"
                    ></path>
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="32"
                      d="M400 256H112"
                    ></path>
                  </svg>
                </n-icon>
              </div>
            </n-upload> -->
          </div>
          <div class="text-center ml-20" style="margin-left:50px;">
            <p class="mb-1">相关证明二</p>
            <Upload @dataChange="dataChangeER" v-bind:path="formModel.qualification" />
            <!--            <n-upload-->
            <!--              action="#"-->
            <!--              :default-upload="false"-->
            <!--              :file-list="[]"-->
            <!--              @change="(...args) => handleUploadChange(0, ...args)"-->
            <!--            >-->
            <!--              <div-->
            <!--                class="cursor-pointer border-2 border-gray-200 flex justify-center items-center"-->
            <!--                style="width: 142px; height: 142px"-->
            <!--              >-->
            <!--                <n-icon size="60" color="#ccc">-->
            <!--                  <svg-->
            <!--                    xmlns="http://www.w3.org/2000/svg"-->
            <!--                    xmlns:xlink="http://www.w3.org/1999/xlink"-->
            <!--                    viewBox="0 0 512 512"-->
            <!--                  >-->
            <!--                    <path-->
            <!--                      fill="none"-->
            <!--                      stroke="currentColor"-->
            <!--                      stroke-linecap="round"-->
            <!--                      stroke-linejoin="round"-->
            <!--                      stroke-width="32"-->
            <!--                      d="M256 112v288"-->
            <!--                    ></path>-->
            <!--                    <path-->
            <!--                      fill="none"-->
            <!--                      stroke="currentColor"-->
            <!--                      stroke-linecap="round"-->
            <!--                      stroke-linejoin="round"-->
            <!--                      stroke-width="32"-->
            <!--                      d="M400 256H112"-->
            <!--                    ></path>-->
            <!--                  </svg>-->
            <!--                </n-icon>-->
            <!--              </div>-->
            <!--            </n-upload>-->
          </div>
        </div>

        <!-- <div class="inline-block text-xl title-line mt-10 mintitle_text" style="margin-top:40px;">信息补录</div> -->
        <n-form class="mt-8" style="margin-top:50px;padding-right:30px;" require-mark-placement="left"
          label-placement="left" label-width="110px" :rules="formRules" :model="formModel" ref="formRef">
          <n-grid :x-gap="16">
            <n-form-item-gi :span="8" label="姓名" path="stuName">
              <n-input :disabled="true" placeholder="请输入姓名" v-model:value="formModel.stuName" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="性别" path="sex">
              <n-select :disabled="true" placeholder="请选择性别" :options="sex" v-model:value="formModel.sex" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="身份证号" path="idNumber">
              <n-input :disabled="true" placeholder="请输入身份证号" v-model:value="formModel.idNumber" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="证件类型" path="certificateType">
              <n-select :disabled="true" placeholder="请选择证件类型" :options="type_of_certificate"
                v-model:value="formModel.certificateType" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="出生日期" path="birthDate">
              <n-date-picker :disabled="true" type="date" class="w-full" placeholder="请选择出生日期"
                v-model:value="formModel.birthDate" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="政治面貌">
              <n-select placeholder="请选择政治面貌" :options="political_status" v-model:value="formModel.politicalStatus" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="移动联系电话" path="mobilePhone">
              <n-input placeholder="请输入移动联系电话" v-model:value="formModel.mobilePhone" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="户口性质" path="accountNature">
              <n-select placeholder="请选择户口性质" :options="account_type" v-model:value="formModel.accountNature" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="国籍">
              <n-select :disabled="true" placeholder="请选择国籍" :options="nation" v-model:value="formModel.nation" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="民族">
              <n-select :disabled="true" placeholder="请选择民族" :options="nationality"
                v-model:value="formModel.nationality" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="所属单位">
              <n-input placeholder="请输入所属单位" v-model:value="formModel.affiliation" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="最高学历">
              <n-select placeholder="请选择最高学历" v-model:value="formModel.education" :options="education" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="户籍地址 省">
              <n-select placeholder="请选择户籍省份" :options="selectCity.province" :value="formModel.domicileProvinceCode"
                :on-update:value="domicileProvinceCodeChange" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="市">
              <n-select placeholder="请选择户籍市" :value="formModel.domicileCityCode" :options="selectCity.city"
                :on-update:value="domicileCityCodeChange" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="区">
              <n-select placeholder="请选择户籍区" :options="selectCity.area"
                v-model:value="formModel.domicileDistrictCode" />
            </n-form-item-gi>
            <n-form-item-gi :span="8" label="街道">
              <n-input placeholder="请输入街道" v-model:value="formModel.domicileStreet" />
            </n-form-item-gi>
            <n-form-item-gi :span="16" label="户籍地址">
              <n-input placeholder="请输入户籍地址" v-model:value="formModel.domicileAddress" />
            </n-form-item-gi>
          </n-grid>
        </n-form>
        <div class="flex justify-center mt-10">
          <el-button :loading="saveLoading" class="mx-auto px-10 allbtncolor queren_btn" type="primary" size="large"
            @click="handleSubmit">
            <span class="">确认补录</span>
          </el-button>
        </div>
      </div>

      <!--      线下 学时 弹框 开始-->
      <n-modal v-model:show="showModalX">
        <n-card style="width: 1000px" title="线下学时" :bordered="false" size="huge">
          <Xperiod @my-emit="parentEmit" :msg="userInfo.id" />
        </n-card>
      </n-modal>
      <!--      线下 学时 弹框 结束-->

      <!--      网络课学时 弹框 开始-->
      <n-modal v-model:show="showModalWL">
        <n-card style="width: 1100px" title="网络课学时" :bordered="false" size="huge">
          <WLperiod :msgWl="userInfo.id" />
        </n-card>
      </n-modal>
      <!--      网络课学时 弹框 结束-->

      <!--      直播学时 弹框 开始-->
      <n-modal v-model:show="showModalZB">
        <n-card style="width: 1100px" title="直播课学时" :bordered="false" size="huge">
          <ZBperiod :msgZB="userInfo.id" />
        </n-card>
      </n-modal>
      <!--      直播学时 弹框 结束-->

      <!--      考试成绩 弹框 开始-->
      <n-modal v-model:show="showModalKS">
        <n-card style="width: 1100px" title="考试成绩" :bordered="false" size="huge">
          <KSperiod :msgKS="userInfo.id" />
        </n-card>
      </n-modal>
      <!--      考试成绩 弹框 结束-->

      <!--      专家评审详情 开始-->
      <n-modal v-model:show="showModalPS">
        <n-card style="width: 1100px" title="评审详情" :bordered="false" size="huge">
          <PSperiod :msgPS="userInfo.id" />
        </n-card>
      </n-modal>
      <!--      专家评审详情 结束-->
    </template>
  </NSpin>
</template>

<script setup>
import { reactive, ref } from 'vue';
import {
  getUserInfoApi,
  getKeysApi,
  getSelectCityApi,
  saveInformationSupplement,
  getEligibilityStu,
  getStuCredit
} from '@/api';
import { mapOption, dateFormat } from '@/utils';

import Xperiod from './studyDetails/Xperiod';
import WLperiod from './studyDetails/WLperiod';
import ZBperiod from './studyDetails/ZBperiod';
import KSperiod from './studyDetails/KSperiod';
import PSperiod from './studyDetails/PSperiod';

import Upload from './Upload';

// 线下 学时 弹框
const showModalX = ref(false);
const showModalWL = ref(false);
const showModalZB = ref(false);
const showModalKS = ref(false);
const showModalPS = ref(false);

const showSituation = ref(true);

const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const codeStr =
  'sex,type_of_certificate,political_status,account_type,nation,nationality,education,health,marriage';
const sex = ref([]);
const type_of_certificate = ref([]);
const political_status = ref([]);
const account_type = ref([]);
const nation = ref([]);
const nationality = ref([]);
const education = ref([]);
const formModel = reactive({
  id: '',
  // 姓名
  stuName: '',
  sex: null,
  // 身份证号
  idNumber: '',
  // 证件类型
  certificateType: null,
  // 出生日期
  birthDate: null,
  // 政治面貌
  politicalStatus: null,
  // 移动联系电话
  mobilePhone: '',
  // 户口性质
  accountNature: null,
  // 国籍
  nation: null,
  // 民族
  nationality: null,
  // 所属单位
  affiliation: '',
  // 学历
  education: null,
  // 省-编号
  domicileProvinceCode: null,
  // 市-编号
  domicileCityCode: null,
  // 区-编号
  domicileDistrictCode: null,
  // 户籍街道
  domicileStreet: '',
  // 户籍地址
  domicileAddress: '',
  //  相关证明1
  proof: '',
  //  相关证明2
  qualification: '',
});
const formRules = {
  stuName: {
    required: true,
    message: '请输入姓名',
    trigger: ['blur', 'input'],
    whitespace: true,
  },
  sex: {
    required: true,
    type: 'number',
    message: '请选择性别',
    trigger: ['blur', 'change'],
  },
  idNumber: {
    required: true,
    message: '请输入身份证号',
    trigger: ['blur', 'input'],
    whitespace: true,
  },
  certificateType: {
    required: true,
    type: 'number',
    message: '请选择证件类型',
    trigger: ['blur', 'change'],
  },
  birthDate: {
    required: true,
    type: 'number',
    message: '请选择出生日期',
    trigger: ['blur', 'change'],
  },
  mobilePhone: {
    required: true,
    message: '请输入移动联系电话',
    trigger: ['blur', 'input'],
    whitespace: true,
  },
  accountNature: {
    required: true,
    type: 'number',
    message: '请选择户口性质',
    trigger: ['blur', 'change'],
  },
};

const userInfo = reactive({});
const initLoading = ref(true);
function updacredit (value) {
  if (value) {
    return (value / 60 / 45).toFixed(2)

  } else {
    return 0
  }
}
function updatapercentage (value, value2) {
  if (value && value2) {
    let num = Math.ceil(value * 100 / value2)
    if (num > 100) {
      num = 100
    }
    return num

  } else {
    return 0
  }
}
const credit = ref({})
getStuCredit().then(res => {
  console.log(res, 'getStuCredit')
  credit.value = res.data
})
getUserInfoApi()
  .then(res => res.data)
  .then(res => {
    Object.assign(userInfo, res);
    const {
      id,
      stuName,
      sex,
      idNumber,
      certificateType,
      birthDate,
      politicalStatus,
      mobilePhone,
      accountNature,
      nation,
      nationality,
      affiliation,
      education,
      domicileProvinceCode,
      domicileCityCode,
      domicileDistrictCode,
      domicileStreet,
      domicileAddress,
      proof,
      qualification,
    } = res;
    formModel.id = id;
    formModel.stuName = stuName;
    formModel.sex = sex;
    formModel.idNumber = idNumber;
    formModel.certificateType = certificateType;
    formModel.birthDate = +new Date(birthDate);
    formModel.politicalStatus = politicalStatus;
    formModel.mobilePhone = mobilePhone;
    formModel.accountNature = accountNature;
    formModel.nation = nation;
    formModel.nationality = nationality;
    formModel.affiliation = affiliation;
    formModel.education = education;
    formModel.domicileProvinceCode = domicileProvinceCode;
    formModel.domicileCityCode = domicileCityCode;
    formModel.domicileDistrictCode = domicileDistrictCode;
    formModel.domicileStreet = domicileStreet;
    formModel.domicileAddress = domicileAddress;
    formModel.proof = proof;
    formModel.qualification = qualification;
    if (domicileCityCode != null) {
      getCity('city', domicileProvinceCode);
    }
    if (domicileDistrictCode != null) {
      getCity('area', domicileCityCode);
    }

    getEligibilityStu({ stuId: userInfo.id }).then(res => {
      Object.assign(tableSummaryData, res);
      showSituation.value = false;
    });
  })
  .finally(() => (initLoading.value = false));

// 线上、线下表格数据
const tableSummaryData = reactive({});

getKeysApi(codeStr)
  .then(res => res.data)
  .then(res => {
    const {
      sex: _sex,
      // 证件类型
      type_of_certificate: _type_of_certificate,
      // 政治面貌
      political_status: _political_status,
      // 户口性质
      account_type: _account_type,
      // 国籍
      nation: _nation,
      // 民族
      nationality: _nationality,
      // 学历
      education: _education,
    } = res;
    const selectorFormatOptions = {
      value: 'label',
      key: 'value',
    };
    sex.value = mapOption(_sex, selectorFormatOptions);
    console.log(sex.value);
    type_of_certificate.value = mapOption(_type_of_certificate, selectorFormatOptions);
    political_status.value = mapOption(_political_status, selectorFormatOptions);
    account_type.value = mapOption(_account_type, selectorFormatOptions);
    nation.value = mapOption(_nation, selectorFormatOptions);
    nationality.value = mapOption(_nationality, selectorFormatOptions);
    education.value = mapOption(_education, selectorFormatOptions);
  });

const selectCity = reactive({
  province: [],
  city: [],
  area: [],
});
function domicileProvinceCodeChange (value) {
  formModel.domicileProvinceCode = value;
  formModel.domicileCityCode = null;
  formModel.domicileDistrictCode = null;
  selectCity.city = [];
  selectCity.area = [];
  getCity('city', value);
}
function domicileCityCodeChange (value) {
  formModel.domicileCityCode = value;
  formModel.domicileDistrictCode = null;
  selectCity.area = [];
  getCity('area', value);
}
function getCity (key = 'province', code = '00') {
  const selectorFormatOptions = {
    name: 'label',
    code: 'value',
  };
  getSelectCityApi(code)
    .then(res => res.data)
    .then(res => {
      selectCity[key] = mapOption(res, selectorFormatOptions);
    });
}
getCity();

function handleUploadChange (...args) {
  console.log(args);
}

// 上传图片路径
function dataChange (params) {
  console.log(params);
  formModel.proof = params;
  console.log('的境况的九分裤');
  console.log(formModel.proof);
}
function dataChangeER (params) {
  formModel.qualification = params;
}

const saveLoading = ref(false);
const formRef = ref(null);
async function handleSubmit () {
  formRef.value.validate(errors => {
    if (errors) {
      return;
    }
  });
  saveLoading.value = true;
  try {
    const res = await saveInformationSupplement({
      ...userInfo,
      ...formModel,
      birthDate: dateFormat(new Date(formModel.birthDate), 'yyyy-MM-dd'),
      // // 相关证明1
      // proof: 'idCard/2021-07-31/adb3d9b4-1b0e-468a-ad96-b22b11b0c717.jpg',
      // // 相关证明2
      // qualification: 'idCard/2021-07-31/c5d9bc31-455e-4eb5-88fa-f0be9498f8c0.jpg',
    });
    if (res.code === 200) {
      window.message.success('保存成功');
    } else {
      window.message.error('保存失败');
    }
  } catch (err) {
    // err
    window.message.error('保存失败');
  }
  saveLoading.value = false;
}

// 线下学时
function xclick () {
  console.log(userInfo.id);
  showModalX.value = true;
}
// 子组件调用
function parentEmit (val) {
  alert(val);
}
// 网络课学时 详情
function clickWl () {
  showModalWL.value = true;
}
// 直播学时详情
function clickZB () {
  return
  showModalZB.value = true;
}

// 考试成绩
function clickExam () {
  showModalKS.value = true;
}

// 评审详情
function appraisal () {
  showModalPS.value = true;
}
</script>
<style>
.title-line:after {
}
</style>
<style lang="scss" scoped>
.queren_btn {
  background-color: #fff;
  border: 1px solid #2d60f6;
  color: #2d60f6;
  border-radius: 40px;
  // width: 180px;
  font-size: 16px;
}
.user_info th {
  font-size: 16px;
}
.usernamecss {
  font-size: 26px;
  color: #111;
  font-weight: 200;
}
.mintitle_text {
  font-size: 22px;
  color: #111;
}
.border-bottoms {
  border-bottom: 1px solid rgba(209, 213, 219);
}
.cred {
  color: red;
}
.cgr {
  color: rgb(0, 255, 12);
}
.title-line {
  position: relative;
  text-align: left;
  padding-bottom: 10px;
  &:after {
    position: absolute;
    content: '';
    height: 6px;
    width: 44px;
    background-color: #2d60f6;
    left: 0;
    bottom: -5px;
    transform: translateX(0);
  }
}
.suspension:hover {
  cursor: pointer;
}
.ambo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // margin: 0 50px 0 0;
  margin-right: 10px;
}
.percentage-label {
  // margin-top: 20px;
  margin: 10px 0;
}
.banjiname {
  display: inline-block;
  margin-left: 80px;
}
.percentage-label2 {
  font-weight: 300;
  color: #6b7280;
}
.yixuekeshi {
  width: 80px;
  display: inline-block;
  text-align: right;
  font-weight: 300;
  color: #6b7280;
}
.yixuekeshi_dian {
  display: block;

  width: 8px;
  border-radius: 50%;
  height: 8px;
  background-color: red;
  margin-right: 6px;
}
.yixuekeshi_dian.active {
  background-color: rgb(0, 255, 12);
}
.yixuekeshi.top {
  font-size: 18px;
  color: #333;
  padding-right: 10px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
}
.jigouico {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-top: -4px;
}
</style>
